var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfile({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.70825 7C8.158 7 9.33325 5.82475 9.33325 4.375C9.33325 2.92525 8.158 1.75 6.70825 1.75C5.2585 1.75 4.08325 2.92525 4.08325 4.375C4.08325 5.82475 5.2585 7 6.70825 7Z",
    fill: "#A9A9A9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.70833 8.45703C4.76146 8.45703 0.875 9.36898 0.875 11.1793V12.5404H12.5417V11.1793C12.5417 9.36898 8.65521 8.45703 6.70833 8.45703Z",
    fill: "#A9A9A9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile);
export default __webpack_public_path__ + "static/media/profile.c94cded786d442b6038b8432dd09ce7f.svg";
export { ForwardRef as ReactComponent };